import "./OfferCreateModal.scss"
import pictogramRental from "assets/img/pictogram/rental.svg"
import pictogramSale from "assets/img/pictogram/sale.svg"

import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"

import { Grid, GridItem } from "components/Grid"
import Modal from "components/Modal/Modal"
import Pictogram from "components/Pictogram/Pictogram"
import { Purpose } from "config/constants"
import Routes from "@/routes"
import { getPurposeLabel } from "utils/utils"
import { Guid } from "@/types"

export type OfferCreateModalProps = {
    onClose(): void
    copyOfferId?: Guid
    copyReservationId?: Guid
}

const OfferCreateModal: FunctionComponent<React.PropsWithChildren<OfferCreateModalProps>> = ({
    onClose,
    copyOfferId,
    copyReservationId,
}) => {
    const { t } = useTranslation()
    const location = useLocation()

    return (
        <Modal
            title={t('createOffer.createNewOffer')}
            maxWidth="586px"
            onClose={onClose}>
            {t('createOffer.whichPurpose')}
            <Grid
                className="my-3"
                columns="1fr 1fr"
                gap="3rem">
                <Link to={Routes.offerCreate.getPath({}, { offerId: copyOfferId, reservationId: copyReservationId, purpose: Purpose.rent, backUrl: location.pathname + location.search })} className="offer-create-modal__item"
                    onClick={onClose}>
                    <Grid
                        columns="64px auto"
                        gap="16px">
                        <GridItem>
                            <Pictogram
                                src={pictogramRental}
                                alt={getPurposeLabel(Purpose.rent)}
                                theme="yellow"
                            />
                        </GridItem>
                        <GridItem>
                            <strong>{getPurposeLabel(Purpose.rent)}</strong>
                            <div className="mt-half">{t('createOffer.rentalDescr')}</div>
                        </GridItem>
                    </Grid>
                </Link>
                <Link to={Routes.offerCreate.getPath({}, { offerId: copyOfferId, reservationId: copyReservationId, purpose: Purpose.sale, backUrl: location.pathname + location.search })} className="offer-create-modal__item"
                    onClick={onClose}>
                    <Grid
                        columns="64px auto"
                        gap="16px">
                        <GridItem>
                            <Pictogram
                                src={pictogramSale}
                                alt={getPurposeLabel(Purpose.sale)}
                                theme="yellow"
                            />
                        </GridItem>
                        <GridItem>
                            <strong>{getPurposeLabel(Purpose.sale)}</strong>
                            <div className="mt-half">{t('createOffer.saleDescr')}</div>
                        </GridItem>
                    </Grid>
                </Link>
            </Grid>
        </Modal>
    )
}

export default OfferCreateModal
